import { render, staticRenderFns } from "./AppointmentChooseBranchPage.vue?vue&type=template&id=6c9a2412"
import script from "./AppointmentChooseBranchPage.vue?vue&type=script&lang=ts"
export * from "./AppointmentChooseBranchPage.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentChooseBranchPage.vue?vue&type=style&index=0&id=6c9a2412&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports